import React, { Component, useEffect } from 'react';
import { NavBar, Toast  } from 'antd-mobile';
import {  useSearchParams ,useNavigate} from 'react-router-dom';
import { styled } from 'styled-components';
import { getAppSafeTopArea } from '@/utils/utils';

const NavBarView = styled.div`
  &.nav-bar{
    color: #fff;
    background-color: #0158B2;
    padding-top: env(safe-area-inset-top);
    padding-top: constant(safe-area-inset-top);
    .am-navbar{
      background-color: #0158B2;
    }
  }

`


interface NavBarProps {
  leftSlot?: JSX.Element;
  centerSlot?: JSX.Element;
  rightSlot? : JSX.Element; 
  title?: JSX.Element|string;
  onBack?: () => void
  // history
}
export const DhbNavBar = (props:NavBarProps) => {
  let nagative = useNavigate()
  const { onBack = () => nagative(-1) } = props
  let [search] = useSearchParams()
  let statusBarHeight = Number(search.get('statusBarHeight')) || 0
  let from = search.get('from')
  const defaultLeftSlot = <div className="leftSlot" onClick={() => nagative(-1)}></div>
  const { leftSlot = defaultLeftSlot, centerSlot, rightSlot, title } = props;
  if (!statusBarHeight) {
    statusBarHeight = 30;
  }
  // let paddingTop = from == 'android' ? Number(statusBarHeight) / window.devicePixelRatio + 'px': Number(statusBarHeight) + 'px'
  let paddingTop = getAppSafeTopArea()
  return (
    <NavBarView className="nav-bar" style={{ paddingTop: paddingTop }}>
      <NavBar right={rightSlot}  onBack={onBack}  >
        <div className="nav-center">{title}</div>
      </NavBar>
    </NavBarView>
  );
};
